import {
  Box,
  Button,
  Center,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  VStack,
} from "@chakra-ui/react";

import axios from "axios";
import SuccessScreen from "components/send-whatsapp-components/success-screen";
import { NotFound } from "pages/not-found";
import { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useRouter } from "routes/router-control/use-router";
import { phoneFormatMask, telefoneFixoFormatMask } from "utils/string-formats";

export function SendWhatsappPage() {
  const [isSended, setIsSended] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [whatsAppNumber, setWhatsAppNumber] = useState("");
  // const [captchaValidated, setCaptchaValidated] = useState(false);

  // const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const router = useRouter();
  const params = new URLSearchParams(router.search);
  const id = params.get("c");

  // const handleCaptchaChange = (value: string | null) => {
  // setCaptchaValidated(!!value);
  // };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_PUBLIC_API_URL}/atendimentos/receive-external-contact`,
        { c: id, w: whatsAppNumber }
      );

      // Toast({
      //   title: "Enviado",
      //   description: `Número ${whatsAppNumber} enviado com sucesso!`,
      //   status: "success",
      //   duration: 3000,
      //   isClosable: true,
      // });
      setIsSended(true);
      setWhatsAppNumber("");
    } catch (e) {
      alert("Erro ao enviar");
      // Toast({ title: "Erro ao enviar", status: "error", duration: 3000 });
    } finally {
      setIsLoading(false);
    }
  };

  return !id ? (
    <NotFound />
  ) : isSended ? (
    <SuccessScreen />
  ) : (
    <Center w="100%" minH="100vh" pb={{ base: "50vw", md: "0px" }} bg="#e5f8ee">
      <Box
        maxW={{ md: "md" }}
        mx={{ base: "15px", md: "auto" }}
        w="100%"
        mt={10}
        p={6}
        borderWidth={1}
        borderRadius="lg"
        boxShadow="xl"
        bg="white"
        borderColor="#25D366"
      >
        <Heading size={{ base: "lg", md: "md" }} color="#075E54">
          Informe seu contato
        </Heading>

        <Text
          mt="8px"
          mb="10px"
          fontSize={{ base: "16px", md: "14px" }}
          fontStyle="italic"
          color="rgba(0, 0, 0, 0.5)"
        >
          Nossos especialistas estão todos em atendimento, por favor deixe seu
          telefone que entraremos em contato.
        </Text>

        <VStack spacing={4}>
          <FormControl>
            <FormLabel color="#075E54" fontSize={{ base: "17px", md: "16px" }}>
              Número do WhatsApp
            </FormLabel>
            <Input
              placeholder="(xx) xxxxx-xxxx"
              value={
                whatsAppNumber[2] === "9"
                  ? phoneFormatMask(whatsAppNumber).value
                  : telefoneFixoFormatMask(whatsAppNumber).value
              }
              onChange={(e) => {
                setWhatsAppNumber(
                  e.target.value.replace(/\D/g, "")[2] === "9"
                    ? phoneFormatMask(e.target.value).raw
                    : telefoneFixoFormatMask(e.target.value).raw
                );
              }}
              _placeholder={{ color: "rgba(0, 0, 0, 0.5)" }}
              h="45px"
              border="1px solid #25D366"
              _focus={{ border: "1px solid #25D366" }}
              inputMode="numeric"
              focusBorderColor="#25D366"
            />
          </FormControl>
        </VStack>

        <Button
          mt="24px"
          leftIcon={<FaWhatsapp size="22px" />}
          fontSize={{ base: "17px" }}
          onClick={handleSubmit}
          isDisabled={
            isSended ||
            (whatsAppNumber[2] === "9"
              ? whatsAppNumber.length !== 11
              : whatsAppNumber.length !== 10)
          }
          h="50px"
          aria-label="Enviar número do WhatsApp"
          bg="#25D366"
          _hover={{ bg: "#1ebe5d" }}
          _disabled={{
            _hover: { bg: "#25D366" },
            opacity: 0.5,
            cursor: "not-allowed",
          }}
          color="white"
          width="full"
          type="submit"
          loadingText="Enviando"
          borderRadius="6px"
          isLoading={isLoading}
        >
          Enviar
        </Button>
      </Box>
    </Center>
  );
}
